/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_TestInputs */

const en_notify_test = /** @type {(inputs: Notify_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a test notification`)
};

const de_notify_test = /** @type {(inputs: Notify_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test-Mitteilung senden`)
};

/**
* | output |
* | --- |
* | "Send a test notification" |
*
* @param {Notify_TestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_test = /** @type {((inputs?: Notify_TestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_TestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_test(inputs)
	return en_notify_test(inputs)
});